import { Controller } from '@hotwired/stimulus'
import 'lightgallery.js'

/**
 * Opens Associated Person photos full-size via lightGallery.
 *
 * The controller element is a gallery container holding one or more `<a class="ap-photo__image">`
 * anchors whose `href` is the full-size image and whose inner `<img>` is the thumbnail. Used on
 * the Show page for the primary photo (single anchor), the Photos card (all photos) and the audit
 * trail's before/after photo cells.
 */
export default class extends Controller<HTMLElement> {
  connect (): void {
    const lg = (window as unknown as { lightGallery?: (el: Element, opts: object) => void }).lightGallery

    // Bind once: lightGallery stamps the element with an lg-uid, so a re-connect is a no-op.
    if (typeof lg === 'function' && this.element.getAttribute('lg-uid') === null) {
      lg(this.element, { mode: 'lg-fade', selector: '.ap-photo__image' })
    }
  }
}
